import React from 'react';
import { NavLink, useParams } from 'react-router-dom';
import './MobileBottomNav.css';

function MobileBottomNav() {
  const { landId, cropId } = useParams();

  if (!landId || !cropId) return null;

  const base = `/dashboard/land/${landId}/crop/${cropId}`;

  const navItems = [
    { path: `${base}`, label: 'الوضع المالي', icon: 'grid_view', end: true },
    { path: `${base}/income`, label: 'الايرادات', icon: 'trending_up', end: false },
    { path: `${base}/suggestions`, label: 'الاقتراحات', icon: 'auto_awesome', end: false },
    { path: `${base}/ai-chat`, label: 'الدردشة', icon: 'smart_toy', end: false },
    { path: `${base}/expenses`, label: 'المصاريف', icon: 'payments', end: false },
    { path: `${base}/reports`, label: 'التقارير', icon: 'bar_chart', end: false },
  ];

  return (
    <nav className="mobile-bottom-nav" aria-label="القائمة السفلية">
      {navItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          end={item.end}
          className={({ isActive }) =>
            isActive ? 'mobile-nav-item is-active' : 'mobile-nav-item'
          }
        >
          <span className="material-symbols-outlined mobile-nav-icon">{item.icon}</span>
          <span className="mobile-nav-label">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}

export default MobileBottomNav;
